import { Observable } from 'rxjs';
import { Observer } from 'rxjs';
import { AnonymousSubject } from 'rxjs/internal/Subject';
import socketIO from 'socket.io-client';

export class RxSocket<DT = any> {
  private socket: SocketIOClient.Socket;

  constructor(url: string, options?: SocketIOClient.ConnectOpts) {
    this.socket = socketIO(url, options);
  }

  public disconnect(): void {
    this.socket.close();
  }

  public connect(): void {
    this.socket.connect();
  }

  public observable<T = DT>(event: string): Observable<T> {
    return this.createEventObservable<T>(event);
  }

  public subject<T = DT>(event: string): AnonymousSubject<T> {
    return this.createEventSubject<T>(event);
  }

  private createEventSubject<T>(event: string): AnonymousSubject<T> {
    const incoming = this.createEventObservable<T>(event);
    const outgoing: Observer<T> = {
      next: (data: T) => {
        this.socket.emit(event, data);
      },
      complete: () => null,
      error: () => null
    };
    return new AnonymousSubject(outgoing, incoming);
  }

  private createEventObservable<T>(event: string): Observable<T> {
    return Observable.create((incoming: Observer<T>) => {
      this.socket.on(event, (data: T) => {
        incoming.next(data);
      });
      return () => { this.onEventSubjectUnsubscribe(event); };
    });
  }

  private onEventSubjectUnsubscribe(event: string): void {
    this.socket.disconnect()
  }

}